import { render, staticRenderFns } from "./UserGroupQueryList.vue?vue&type=template&id=fba49542&scoped=true&"
import script from "./UserGroupQueryList.vue?vue&type=script&lang=js&"
export * from "./UserGroupQueryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba49542",
  null
  
)

export default component.exports